var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-autocomplete',{attrs:{"fetch-suggestions":_vm.querySearchAsync,"placeholder":"星广汇红人检索：输入关键字","clearable":""},on:{"select":_vm.handleSelect,"clear":_vm.clearSelect},model:{value:(_vm.userName),callback:function ($$v) {_vm.userName=$$v},expression:"userName"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }